export interface FormField {
    name: string;
}

// TODO: добавить типизацию на FormManager
export type FormManagerValues = {
    [key: string]: any;
};

export type FormManagerErrors = {
    [key: string]: string[];
};

export type SubmitData = {
    values: FormManagerValues | null;
    errors: FormManagerErrors | null;
};

export enum ValidationStrategy {
    OnChange = "ON_CHANGE",
    OnSubmit = "ON_SUBMIT",
}

export interface FormManagerOptions {
    initialValues: FormManagerValues;
    onSubmit?:
        | ((data: SubmitData) => void)
        | ((data: SubmitData) => Promise<void>);
    onValidationError?: (data: {
        values: FormManagerValues;
        errors: FormManagerErrors;
    }) => void;
    resolver: Resolver;
    unregisterOnUnmount: boolean;
    validationStrategy: ValidationStrategy;
}

export type FormManagerValidationResult = {
    data: FormManagerValues | null;
    errors: FormManagerErrors | null;
};
export type ResolverCreator<T> = (schema: T) => Resolver;

export type Resolver = (
    values: FormManagerValues
) => Promise<FormManagerValidationResult>;

export type UpdateValueOptions = {
    shouldTouch: boolean;
};
